import { render, staticRenderFns } from "./FeeConfigDetailHis.vue?vue&type=template&id=02ecbbe9&scoped=true"
import script from "./FeeConfigDetailHis.vue?vue&type=script&lang=js"
export * from "./FeeConfigDetailHis.vue?vue&type=script&lang=js"
import style0 from "./FeeConfigDetailHis.vue?vue&type=style&index=0&id=02ecbbe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ecbbe9",
  null
  
)

export default component.exports